export const MSAAS_LISTING_ROUTES = {
  get: '/b2b/job-listings/by-employer/{employerId}',
  post: '/b2b/job-listings',
  patch: '/b2b/job-listings/{id}',
  delete: '/b2b/job-listings/{id}',
};

export const MSAAS_LISTING_ACTIVATE_ROUTES = {
  patch: '/b2b/job-listings/{id}/activate',
};

export const MSAAS_LISTING_DEACTIVATE_ROUTES = {
  patch: '/b2b/job-listings/{id}/deactivate',
};

export const MSAAS_LISTING_CANCEL_ROUTES = {
  post: '/b2b/job-listings/{id}/cancel',
};

export const MSAAS_LISTING_RELIST_ROUTES = {
  post: '/b2b/job-listings/{id}/relist',
};

export const MSAAS_FACILITIES_ROUTES = {
  put: '/b2b/job-listings/{listingId}/facilities',
};

export const MSAAS_STATES_ROUTES = {
  put: '/b2b/job-listings/{listingId}/states',
};

export const MSAAS_GEOGRAPHIES_ROUTES = {
  put: '/b2b/job-listings/{listingId}/geographies',
};

export const MSAAS_PROVIDERS_ROUTES = {
  get: '/b2b/job-listings/{listingId}/providers',
  put: '/b2b/job-listings/{listingId}/providers',
};

export const MSAAS_DETAILS_ROUTES = {
  post: '/b2b/details',
  patch: '/b2b/details/{id}',
  delete: '/b2b/details/{id}',
};

export const MSAAS_DETAIL_CALCULATIONS_ROUTES = {
  post: '/b2b/details/calculations',
};

export const MSAAS_DETAIL_SUMMARY_ROUTES = {
  post: '/b2b/details/contract-summary',
};
